import React from 'react';
import { MedicalDocumentForm } from '#components';

const MedicalDocumentCreatePage = () => {
  return <MedicalDocumentForm type='CREATE' />;
};

export default MedicalDocumentCreatePage;
